import { Component, input, InputSignal } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  imports: [NgStyle],
})
export class SpinnerComponent {
  public borderWidth: InputSignal<string> = input('2px');
  public color: InputSignal<string> = input('var(--blue)');
  public spinnerSize: InputSignal<string> = input('20px');
}
